<template>
  <div class="add-box">
    <el-form
      ref="processform"
      :model="processform"
      label-width="120px"
      class="user-form"
    >
      <el-form-item label="流程名称:">
        <el-input
          v-model="processform.name"
          placeholder="流程名称"
          class="user-input"
        />
      </el-form-item>
      <el-form-item label="流程别名:">
        <el-input
          v-model="processform.aliasName"
          placeholder="流程别名"
          class="user-input"
        />
      </el-form-item>
      <el-form-item label="流程编号:">
        <el-input
          v-model="processform.flowCode"
          placeholder="流程编号"
          class="user-input"
        />
      </el-form-item>
      <el-form-item label="父级流程:">
        <el-cascader
          ref="lastprocess"
          :show-all-levels="false"
          :options="lastprocessList"
          :props="optionProps"
          class="user-input"
          placeholder="一级菜单"
          clearable
          @change="handleItemChange"
        />
      </el-form-item>
      <el-form-item label="下一步流程:">
        <el-cascader
          ref="nextprocess"
          :show-all-levels="false"
          :options="lastprocessList"
          :props="optionProps"
          class="user-input"
          placeholder="一级菜单"
          clearable
          @change="handleItemChange2"
        />
      </el-form-item>
      <el-form-item label="滚动流程:">
        <el-cascader
          ref="rollprocess"
          :show-all-levels="false"
          :options="lastprocessList"
          :props="optionProps"
          class="user-input"
          placeholder="一级菜单"
          clearable
          @change="handleItemChange3"
        />
      </el-form-item>
      <el-form-item label="超时不予互助流程:">
        <el-radio-group v-model="processform.isDeleted">
          <el-radio :label="false">否</el-radio>
          <el-radio :label="true">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="分配规则:">
        <el-radio-group v-model="processform.ruleType">
          <el-radio :label="120100">定制</el-radio>
          <el-radio :label="120500">随机</el-radio>
          <el-radio :label="121000">指定流程的经办人</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="processform.ruleType == 120100" label="权重:">
        <el-input
          v-model="processform.weight"
          placeholder="权重，数值越小越优先执行"
          class="user-input"
        />
      </el-form-item>

      <el-form-item v-if="processform.ruleType == 121000" label="指定流程:">
        <el-cascader
          ref="flowBind"
          :show-all-levels="false"
          :options="lastprocessList"
          :props="optionProps"
          class="user-input"
          placeholder="一级菜单"
          clearable
          @change="handleItemChange4"
        />
      </el-form-item>

      <el-form-item label="角色:">
        <el-checkbox-group v-model="processform.roleList">
          <el-checkbox v-for="current in roleList" :key="current.roleId" :label="current.roleId">{{
            current.roleName
          }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click.stop="save">确定</el-button>
        <el-button type="warning" @click.stop="back">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lastprocessList: [],

      optionProps: {
        expandTrigger: 'hover',
        emitPath: false,
        value: 'flowCode',
        label: 'name',
        children: 'children'
      },

      roleList: [],

      processform: {
        name: '',
        aliasName: '',
        flowBind: '0',
        flowBindName: '一级菜单',
        flowCode: '',
        isDeleted: false,
        nextFlow: '',
        nextFlowName: '',
        parentName: '一级菜单',
        parentCode: '0',
        roleList: [],
        rollFlow: '0',
        rollFlowName: '一级菜单',
        ruleType: 120500,
        weight: ''
      }
    }
  },

  created() {
    this.$emit('setCurrentMenu', '流程管理')
    this.getprocess()
    this.getroleList()
  },

  methods: {

    /**
	 * 获取所有的流程数据
	 */
    getprocess() {
      const vm = this
      vm.axios
        .get(vm.homePath() + '/case/flow/select')
        .then((res) => {
          if (res.data.status === '000000') {
            const data = res.data.flowList
            vm.lastprocessList = vm.filterNull(
              vm.toTreeData(data, 'parentCode', 'flowCode')
            )
          } else {
            vm.$alert(res.data.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    filterNull(data) {
      const vm = this
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          data[i].children = undefined
        } else {
          vm.filterNull(data[i].children)
        }
      }
      return data
    },

    /**
	 * 获取角色列表
	 */
    getroleList() {
      const vm = this
      vm.axios
        .get(vm.homePath() + '/case/flow/roleList')
        .then((response) => {
          if (response.data.status === '000000') {
            const data = response.data.roleList
            vm.roleList = data
          } else {
            console.log(response.data.message)
            vm.$alert(
              response.data.message || '服务器繁忙，请稍后重试',
              '提示'
            )
          }
        })
        .catch((error) => console.log(error))
    },

    handleItemChange(val) {
      this.processform.parentCode = val
      this.processform.parentName = this.$refs[
        'lastprocess'
      ].getCheckedNodes()[0].label
    },

    handleItemChange2(val) {
      this.processform.nextFlow = val
      this.deptform.nextFlowName = this.$refs[
        'nextprocess'
      ].getCheckedNodes()[0].label
    },

    handleItemChange3(val) {
      this.deptform.rollFlow = val
      this.deptform.rollFlowName = this.$refs[
        'rollprocess'
      ].getCheckedNodes()[0].label
    },
    handleItemChange4(val) {
      this.deptform.flowBind = val
      this.deptform.flowBindName = this.$refs[
        'flowBind'
      ].getCheckedNodes()[0].label
    },

    /**
	 * 保存流程
	 */
    save() {
      let past = true
      console.log(this.processform.isDeadlineFlow)
      if (this.processform.name == '') {
        this.$alert('流程名称不能为空', '提示')
        past = false
      }
      if (this.processform.aliasName == '') {
        this.$alert('流程别名不能为空', '提示')
        past = false
      }
      if (this.processform.flowCode == '') {
        this.$alert('流程编号不能为空', '提示')
        past = false
      }

      if (this.processform.roleList == []) {
        this.$alert('请选择角色', '提示')
        past = false
      }

      if (past) {
        const vm = this
        vm.axios
          .post(vm.homePath() + '/case/flow/save', vm.processform)
          .then((response) => {
            if (response.data.status === '000000') {
              vm.$alert('增加成功', '提示', {
                callback: (action) => {
                  vm.$router.push('/index/processManage')
                }
              })
            } else {
              console.log(response.data.message)
              vm.$alert(
                response.data.message || '服务器繁忙，请稍后重试',
                '提示'
              )
            }
          })
          .catch((error) => console.log(error))
      }
    },

    back() {
      this.$router.push('/index/processManage')
    }
  }
}
</script>

<style>
</style>

